import request from "@/plugins/axios";

export class ContractApis {
  // 获取合同详情
  static getContractById(id) {
    return request.get(`/Crm/Contract/ContractEntityById?id=${id}`);
  }
  // 新建合同
  static addContract(params) {
    return request.post("/Crm/Contract/AddContractInfo", params);
  }
  // 修改合同
  static editContract(params) {
    return request.post("/Crm/Contract/ModifyContractInfo", params);
  }
  // 审核合同
  static aduitContract(params) {
    return request.post("/Crm/Contract/ContractAudit", params);
  }
  // 获取合同附件上传地址
  static getUploadUrl(fileExt) {
    return request.get(`/Crm/File/FileUploadURL?fileExt=${fileExt}&attachType=1`);
  }

  // 新增合同跟进记录
  static addContFollowLog(params) {
    return request.post(`/Crm/ContractFollowUp/AddContractFollowup`, params);
  }
  // 获取合同跟进记录
  static getContFollowLogs(contractId, pageIndex, pageSize) {
    return request.get(`/Crm/ContractFollowUp/ContractFollowUpPageListByContractId?contractId=${contractId}&pageIndex=${pageIndex}&pageSize=${pageSize}`);
  }

  // 获取合同动态（操作日志）
  static getContDynamicLogs(contractId, pageIndex, pageSize) {
    return request.get(`/Crm/Contract/ContractOperateLogPageListByContractId?contractId=${contractId}&pageIndex=${pageIndex}&pageSize=${pageSize}`);
  }

  // 新增回款计划
  static addReceiptPlan(params) {
    return request.post(`/Crm/ContractCollection/AddContractCollectionPlan`, params);
  }
  // 修改回款计划
  static editReceiptPlan(params) {
    return request.post(`/Crm/ContractCollection/ModifyContractCollectionPlan`, params);
  }
  // 查询回款计划
  static getReceiptPlans(contractId, pageIndex, pageSize) {
    return request.get(`/Crm/ContractCollection/CollectionPlanPageList?contractId=${contractId}&pageIndex=${pageIndex}&pageSize=${pageSize}`);
  }
  // 删除回款计划
  static deleReceiptPlan(planId) {
    return request.delete(`/Crm/ContractCollection/CollectionPlan?planId=${planId}`);
  }

  // 新增合同附件
  static getContractAttachs(contractId) {
    return request.get(`/Crm/Contract/ContractAttachByContractId?contractId=${contractId}`);
  }
  // 新增合同附件
  static addContractAttach(fileData) {
    return request.post(`/Crm/Contract/AddContractAttach`, fileData);
  }
  // 删除合同附件
  static deleContractAttach(attachId) {
    return request.delete(`/Crm/Contract/DelContractAttachById?attachId=${attachId}`);
  }

  // 新增合同回款
  static addReceiptRecord(params) {
    return request.post(`/Crm/ContractCollection/AddContractCollectionRecord`, params);
  }
  // 编辑合同回款
  static editReceiptRecord(params) {
    return request.post(`/Crm/ContractCollection/ModifyContractCollectionRecord`, params);
  }
  // 删除合同回款
  static deleReceiptRecord(recordId) {
    return request.delete(`/Crm/ContractCollection/DelContractCollectionRecord?recordId=${recordId}`);
  }
  // 查询合同回款
  static getReceiptRecords(params) {
    // contractId auditState  pageIndex  pageSize
    return request.get(`/Crm/ContractCollection/CollectionRecordPageList`, { params });
  }
  // 审核合同回款
  static auditReceiptRecord(params) {
    return request.post(`/Crm/ContractCollection/ContractRecordAudit`, params);
  }
  // 获取合同回款信息
  static getRecordById(recordId) {
    return request.get(`/Crm/ContractCollection/CollectionRecordEnByRecordId?recordId=${recordId}`);
  }
  // 获取合同回款附件列表
  static getRecordAttachList(recordId) {
    return request.get(`/Crm/ContractCollection/ContractRecordAttachByRecordId?recordId=${recordId}`);
  }

  // 待我审核的合同列表
  static getStayMyAuditList(params) {
    // applyUserName customerName contractName startDt endDt pageIndex pageSize
    return request.get(`/Crm/Contract/StayAuditContractPageList`, { params });
  }
  // 我已经审核的合同列表
  static getMyAuditedList(params) {
    // applyUserName contractState customerName contractName startDt endDt pageIndex pageSize
    return request.get(`/Crm/Contract/AlreadyAuditContractPageList`, { params });
  }
  // 我创建的的合同列表
  static getMyCreatedList(params) {
    // applyUserName contractState customerName contractName startDt endDt pageIndex pageSize
    return request.get(`/Crm/Contract/MyAddContractPageList`, { params });
  }
  // 抄送给我的合同列表
  static getCopyToMeList(params) {
    // applyUserName contractState customerName contractName startDt endDt pageIndex pageSize
    return request.get(`/Crm/Contract/SendAuditContractPageList`, { params });
  }

  // 待我审核的回款列表
  static getMyReceiptAuditList(params) {
    // applyUserName customerName contractName startDt endDt pageIndex pageSize
    return request.get(`/Crm//ContractCollection/StayAuditContRecordPageList`, { params });
  }
  // 我已经审核的回款列表
  static getMyReceiptAuditedList(params) {
    // applyUserName contractState customerName contractName startDt endDt pageIndex pageSize
    return request.get(`/Crm/ContractCollection/AlreadyAuditContRecordPageList`, { params });
  }
  // 我创建的的回款列表
  static getMyReceiptCreatedList(params) {
    // applyUserName contractState customerName contractName startDt endDt pageIndex pageSize
    return request.get(`/Crm/ContractCollection/MyAddContRecordPageList`, { params });
  }
  // 抄送给我的回款列表
  static getReceiptCopyToMeList(params) {
    // applyUserName contractState customerName contractName startDt endDt pageIndex pageSize
    return request.get(`/Crm/ContractCollection/SendAuditContRecordPageList`, { params });
  }
}
